<template>
    <vue-recaptcha 
        :sitekey="sitekey"
        @expired="onCaptchaExpired"
        @verify="onVerify"
        ref="recaptcha">
    </vue-recaptcha>
</template>
 
<script>
import VueRecaptcha from 'vue-recaptcha';
export default {   
    props: {
        sitekey: String,
        submit: String
    }, 
    components: { 
        'vue-recaptcha': VueRecaptcha
    },
    methods: {
        onCaptchaExpired: function () {
            this.$refs.recaptcha.reset();
            document.getElementById(this.submit).disabled = true;
        },
        onSubmit: function () {
            this.$refs.invisibleRecaptcha.execute()
        },
        onVerify: function (response) {
            let url = "/api/recaptcha/verify/"+response;
            window.axios.get(url)
            .then(response => { 
                if(response.status === 200){
                    //enable submit button
                    document.getElementById(this.submit).disabled = false;
                }
            })
            .catch(error => {
                document.getElementById(this.submit).disabled = true;
                this.loading = false
            })
        },
    },
    mounted() {
        document.getElementById(this.submit).disabled = true;
    }

};
</script>


// WEBPACK FOOTER //
// resources/assets/frontend/js/components/Recaptcha.vue